import * as React from "react";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { useAuthStore } from "@/store/authStore";

const ToastProvider: React.FC = () => {
	const toast = useAuthStore((state) => state.toast);
	const clearToast = useAuthStore((state) => state.clearToast);

	return (
		<Snackbar
			open={!!toast}
			autoHideDuration={5000}
			anchorOrigin={{ vertical: "top", horizontal: "center" }}
			onClose={clearToast}
		>
			<Alert
				onClose={clearToast}
				severity={toast?.severity ?? "info"}
				variant="filled"
				sx={{ width: "100%" }}
			>
				{toast?.message}
			</Alert>
		</Snackbar>
	);
};

export default ToastProvider;
